export const ZONE_REFRESH_MS = 15_000;

export function zonesNeedRefresh(zones: readonly { readonly status: string }[]): boolean {
  return zones.some(zone => zone.status === 'awaiting_setup' || zone.status === 'claimed');
}

export function refreshOnReturn(event: 'focus' | 'visibilitychange', visibility: string): boolean {
  return event === 'focus' || visibility === 'visible';
}

export function refreshFailureAction(status: number | undefined, silent: boolean): 'unauthorized' | 'error' | 'ignore' {
  return status === 401 ? 'unauthorized' : silent ? 'ignore' : 'error';
}
